import { render, staticRenderFns } from "./OptionPropertyAttorneysBackupWorkTogetherYN.vue?vue&type=template&id=245151ef"
import script from "./OptionPropertyAttorneysBackupWorkTogetherYN.vue?vue&type=script&lang=js"
export * from "./OptionPropertyAttorneysBackupWorkTogetherYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports